export const AVO = {
  name: "AVO Fence & Supply",
  slogan: "Custom Fencing. Craftsman Quality.",
  phone: "781-341-2963",
  phoneHref: "tel:+17813412963",
  address: "50 Washington Street, Route 138 (Canton Line)",
  city: "Stoughton, MA 02072",
  hours: [
    { days: "Monday — Friday", time: "8:00 AM – 4:00 PM", note: "Pickups until 3:30 PM" },
    { days: "Saturday", time: "8:00 AM – 12:00 PM", note: "Pickups until 11:30 AM" },
    { days: "Sunday", time: "Closed", note: "" },
  ],
  about:
    "For decades, New England homeowners have relied on AVO Fence & Supply for high-quality fencing materials, gates, and home containment solutions. We offer custom-design services, the largest selection of cedar fencing in the area, and superior vinyl fence systems — sold directly to you, at the pricing you deserve.",
  supplyNote:
    "We supply the finest materials — you create the space. AVO focuses 100% on milling, stocking, and delivering top-tier cedar and vinyl supplies, serving New England's installers, landscapers, and homeowners.",
};

const AVO_CDN = "https://www.avofenceandsupply.com/wp-content/uploads/2020";

export const IMAGES = {
  heroDark:
    "https://images.unsplash.com/photo-1613756178402-ed5c1ea492b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHx3b29kZW4lMjBmZW5jZSUyMGNyYWZ0c21hbiUyMHlhcmQlMjBob3VzZXxlbnwwfHx8fDE3ODk0NjQ0NDZ8MA&ixlib=rb-4.1.0&q=85",
  workshop:
    "https://images.unsplash.com/photo-1787005241276-c839bd7e24c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHxfHx3b29kd29ya2luZyUyMHdvcmtzaG9wJTIwY3JhZnRzbWFuJTIwdGltYmVyfGVufDB8fHx8MTc4OTQ2NDQ1M3ww&ixlib=rb-4.1.0&q=85",
  fence: `${AVO_CDN}/11/fence1.jpg`,
  arbor: `${AVO_CDN}/11/arbors-2515442-1.jpg`,
  gate: `${AVO_CDN}/11/gate.jpg`,
  pergola: `${AVO_CDN}/11/pergolas.jpg`,
  mailbox: `${AVO_CDN}/11/mailbox.jpg`,
  lampPost: `${AVO_CDN}/11/lamp-post.jpg`,
  cedarBoards: `${AVO_CDN}/10/wood.jpeg`,
};

export const PRODUCTS = [
  {
    id: "cedar-fencing",
    name: "Cedar Fencing",
    tag: "Picket · Stockade · Board-on-Board",
    description:
      "Naturally rot-resistant Northern White Cedar, milled to exact spec for decades of New England weather.",
    image: IMAGES.fence,
  },
  {
    id: "custom-gates",
    name: "Custom Gates",
    tag: "Wood & Vinyl · Heavy-Duty Hardware",
    description:
      "Single and double gates built with mortise-and-tenon joinery and structural frames that never sag.",
    image: IMAGES.gate,
  },
  {
    id: "arbors",
    name: "Arbors",
    tag: "Garden Entryways & Archways",
    description:
      "Handcrafted cedar archways that turn a garden path into an entrance worth remembering.",
    image: IMAGES.arbor,
  },
  {
    id: "pergolas",
    name: "Pergolas",
    tag: "Heavy-Beam Shade Structures",
    description:
      "Precision-cut timber pergolas for patios, pools, and outdoor rooms — residential and commercial.",
    image: IMAGES.pergola,
  },
  {
    id: "mailbox-posts",
    name: "Mailbox Posts",
    tag: "Solid Cedar · Pre-Notched",
    description:
      "Classic cedar posts, pre-notched for fast installation and instant curb appeal.",
    image: IMAGES.mailbox,
  },
  {
    id: "lamp-posts",
    name: "Lamp Posts",
    tag: "Wire-Chased Cedar",
    description:
      "Heritage-style lamp posts with internal conduit — traditional looks, modern safety.",
    image: IMAGES.lampPost,
  },
];

export const GALLERY = [
  { image: IMAGES.fence, caption: "Cedar fence, straight off the yard" },
  { image: IMAGES.gate, caption: "Custom cedar gate & hardware" },
  { image: IMAGES.pergola, caption: "Timber pergola, built to spec" },
  { image: IMAGES.arbor, caption: "Garden arbor, handcrafted cedar" },
];

const CDN10 = "https://www.avofenceandsupply.com/wp-content/uploads/2020/10";

export const CATALOG_CATEGORIES = [
  "Cedar Fences",
  "Vinyl Systems",
  "Gates",
  "Arbors & Pergolas",
  "Posts & Caps",
];

const FENCE_DEFAULTS = {
  hasFootage: true,
  hasGates: true,
  grades: ["Premium", "#2 Select", "Economy"],
  posts: ['5×5" Square Cedar', '5" Round Cedar', "5×5 PT Square"],
  caps: ["Nantucket", "Westport", "Flat Cap", "Ball Cap"],
};

export const CATALOG = [
  {
    id: "privacy-board",
    category: "Cedar Fences",
    code: "AV-100",
    name: "Privacy Board Panel",
    tagline: "Solid butted-board privacy — the flagship AVO panel",
    image: IMAGES.fence,
    groups: [
      { key: "height", label: "Height", options: ["4'", "5'", "6'", "8'"] },
      { key: "top", label: "Top Style", options: ["Straight", "Scalloped", "Reverse Scalloped", "Capped"] },
      { key: "boardTop", label: "Board Top", options: ["Pointed", "Dog Ear", "Round", "Classic"] },
    ],
    specs: [
      ["Fill", 'Butted board, 3/4" thick'],
      ["Panel widths", "8' / 10'"],
      ["Fasteners", "Aluminum or stainless ring-shank"],
      ["Pool code", "Yes (6' and higher)"],
    ],
    ...FENCE_DEFAULTS,
  },
  {
    id: "chestnut-hill",
    category: "Cedar Fences",
    code: "AV-200",
    name: "Chestnut Hill",
    tagline: "Open spindle-top classic with 2×2 cedar balusters",
    image: `${CDN10}/gates.jpg`,
    groups: [
      { key: "height", label: "Height", options: ["3'", "4'", "5'", "6'"] },
      { key: "top", label: "Top Style", options: ["Straight", "Scalloped", "Capped", "Stepped"] },
      { key: "topper", label: "Topper", options: ["None", "Lattice Square", "Lattice Diagonal"] },
    ],
    specs: [
      ["Balusters", '2×2" durable cedar'],
      ["Customizable", "Board & baluster heights"],
      ["Panel widths", "8' / 10'"],
    ],
    ...FENCE_DEFAULTS,
  },
  {
    id: "stockade",
    category: "Cedar Fences",
    code: "AV-300",
    name: "Stockade",
    tagline: "Traditional pointed picket, New England's workhorse",
    image: IMAGES.heroDark,
    groups: [
      { key: "height", label: "Height", options: ["4'", "6'", "8'"] },
      { key: "top", label: "Picket Top", options: ["Pointed", "Square", "Scalloped", "Capped"] },
      { key: "spacing", label: "Style", options: ["Solid", "Spaced"] },
    ],
    specs: [
      ["Pickets", '3/4" thick white cedar'],
      ["Fasteners", "Aluminum or stainless ring-shank"],
      ["Panel widths", "8'"],
    ],
    ...FENCE_DEFAULTS,
  },
  {
    id: "universal",
    category: "Cedar Fences",
    code: "AV-400",
    name: 'Universal Panel — "Good Neighbor"',
    tagline: "Tongue-and-groove, picture-framed — identical on both sides",
    image: `${CDN10}/wood.jpeg`,
    groups: [
      { key: "height", label: "Height", options: ["4'", "5'", "6'", "8'"] },
      { key: "top", label: "Top Style", options: ["Straight", "Scalloped", "Reverse Scalloped", "Capped"] },
    ],
    specs: [
      ["Construction", "Interlocking T&G, 5/4 picture frame"],
      ["Rails", "None — fastens direct to posts"],
      ["Both sides", "Finished face each side"],
    ],
    ...FENCE_DEFAULTS,
  },
  {
    id: "post-rail",
    category: "Cedar Fences",
    code: "AV-500",
    name: "Post & Rail",
    tagline: "Estate and pasture fencing — 2-rail or 3-rail",
    image: `${CDN10}/woodwire.png`,
    groups: [
      { key: "rails", label: "Rails", options: ["2-Rail", "3-Rail"] },
      { key: "railMaterial", label: "Rail Material", options: ["Cedar", "Hardwood", "Round Cedar"] },
      { key: "mesh", label: "Wire Mesh", options: ["None", "Welded Wire", "Woven Wire"] },
    ],
    specs: [
      ["Posts", "Locust or cedar"],
      ["Rail profiles", "Square/Diamond, Rustic, Round"],
      ["Mesh option", "Keeps pets in, pests out"],
    ],
    ...FENCE_DEFAULTS,
    grades: null,
    caps: null,
  },
  {
    id: "vinyl-systems",
    category: "Vinyl Systems",
    code: "AV-800",
    name: "Superior Vinyl Fence Systems",
    tagline: "Lifetime vinyl — privacy, picket and ranch rail profiles",
    image: `${CDN10}/vinyl.jpg`,
    groups: [
      { key: "style", label: "Style", options: ["Privacy", "Semi-Privacy", "Picket", "Ranch Rail"] },
      { key: "height", label: "Height", options: ["4'", "5'", "6'"] },
      { key: "color", label: "Color", options: ["White", "Tan", "Gray"] },
    ],
    specs: [
      ["Material", "Virgin PVC, UV-protected"],
      ["Maintenance", "Never paint, never rot"],
      ["Posts", '5×5" routed, heavy-duty available'],
    ],
    ...FENCE_DEFAULTS,
    grades: null,
  },
  {
    id: "gates",
    category: "Gates",
    code: "AV-600",
    name: "Custom Gates",
    tagline: "Mortise-and-tenon joinery, built to your opening",
    image: IMAGES.gate,
    groups: [
      { key: "width", label: "Opening", options: ["3' Walk", "4' Walk", "5' Walk", "10' Double", "12' Double"] },
      { key: "style", label: "Match Style", options: ["Privacy Board", "Chestnut Hill", "Stockade", "Universal", "Custom"] },
      { key: "hardware", label: "Hardware", options: ["Standard Black", "Heavy-Duty", "Stainless"] },
    ],
    specs: [
      ["Joinery", "Mortise & tenon, glued and pinned"],
      ["Frame", "Structural — never sags"],
      ["Sizing", "Built to your exact opening"],
    ],
    hasFootage: false,
    hasGates: false,
    hasQty: true,
    grades: null,
    posts: null,
    caps: null,
  },
  {
    id: "arbors",
    category: "Arbors & Pergolas",
    code: "AV-700",
    name: "Garden Arbors",
    tagline: "Handcrafted cedar entryways for paths and gardens",
    image: IMAGES.arbor,
    groups: [
      { key: "width", label: "Width", options: ["3'", "4'", "5'", "6'"] },
      { key: "top", label: "Top", options: ["Arched", "Flat", "Gabled"] },
    ],
    specs: [
      ["Material", "Northern White Cedar"],
      ["Weather", "Built for New England winters"],
    ],
    hasFootage: false,
    hasGates: false,
    hasQty: true,
    grades: null,
    posts: null,
    caps: null,
  },
  {
    id: "pergolas",
    category: "Arbors & Pergolas",
    code: "AV-701",
    name: "Timber Pergolas",
    tagline: "Heavy-beam shade structures, precision-cut to spec",
    image: IMAGES.pergola,
    groups: [
      { key: "size", label: "Footprint", options: ["10×10", "12×12", "12×16", "16×20", "Custom"] },
      { key: "mount", label: "Mount", options: ["Freestanding", "Attached"] },
    ],
    specs: [
      ["Beams", "Heavy timber cedar"],
      ["Use", "Patios, pools, outdoor rooms"],
    ],
    hasFootage: false,
    hasGates: false,
    hasQty: true,
    grades: null,
    posts: null,
    caps: null,
  },
  {
    id: "posts-caps",
    category: "Posts & Caps",
    code: "AV-900",
    name: "Posts, Caps & Toppers",
    tagline: "Square, round, gothic and chamfer posts — blanks or drilled",
    image: IMAGES.lampPost,
    groups: [
      { key: "postStyle", label: "Post Style", options: ["Square", "Round", "Gothic", "Chamfer"] },
      { key: "cap", label: "Cap", options: ["Nantucket", "Westport", "Flat Cap", "Ball Cap"] },
      { key: "drilled", label: "Milling", options: ["Blank", "Drilled"] },
    ],
    specs: [
      ["Availability", "Blanks or drilled to pattern"],
      ["Also", "Mailbox & lamp posts, wire-chased"],
    ],
    hasFootage: false,
    hasGates: false,
    hasQty: true,
    grades: null,
    posts: null,
    caps: null,
  },
];

export const WOOD_GRADES = [
  { id: "Premium", note: "Appearance-graded both faces, solid tight knots" },
  { id: "#2 Select", note: 'Limited defects, knotholes up to 1/2"' },
  { id: "Economy", note: 'Best value, knotholes up to 1", machine-made' },
];

export const PRICES = {
  "privacy-board": 42,
  "chestnut-hill": 38,
  "stockade": 34,
  "universal": 46,
  "post-rail": 28,
  "vinyl-systems": 55,
  "gates": 485,
  "arbors": 620,
  "pergolas": 2400,
  "posts-caps": 38,
};

export const STOCK_STATUSES = ["In Stock", "Low Stock", "Out of Stock"];
